import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface CollectedRevenueMonthlyTrendItem {
  month: string;
  collected: number;
  outstanding: number;
  scheduled: number;
}

interface CollectedRevenueMonthlyTrendParams {
  sessionId: string;
  startDate: string;
  endDate: string;
}

export const getCollectedRevenueMonthlyTrendAPI = async (
  params: CollectedRevenueMonthlyTrendParams,
) => {
  const response = await baseAPI.get<Array<CollectedRevenueMonthlyTrendItem>>(
    '/dashboard/metrics/collected-revenue/monthly-trend',
    {
      params,
    },
  );
  return response.data;
};

export const useGetCollectedRevenueMonthlyTrend = (
  params: CollectedRevenueMonthlyTrendParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.COLLECTED_REVENUE_MONTHLY_TREND,
      params.sessionId,
      params.startDate,
      params.endDate,
    ],
    queryFn: () => getCollectedRevenueMonthlyTrendAPI(params),
    enabled: !!params.sessionId && !!params.startDate && !!params.endDate,
  });
};
